import { DIALOG_DATA } from '@angular/cdk/dialog';
import { Component, inject } from '@angular/core';
import { AbstractDialogComponent } from '../abstract-dialog.component';
import { PopinLayoutComponent } from '../../layouts/popin-layout/popin-layout.component';
import { ButtonComponent } from '../../ui/button/button.component';

export interface ConfirmOptions {
  title: string;
  content: string;
  validate: string;
  cancel: string;
}

@Component({
  selector: 'app-confirm-dialog',
  templateUrl: './confirm-dialog.component.html',
  styleUrl: './confirm-dialog.component.scss',
  imports: [PopinLayoutComponent, ButtonComponent],
})
export class ConfirmDialogComponent extends AbstractDialogComponent<boolean> {
  protected readonly options: ConfirmOptions =
    inject<ConfirmOptions>(DIALOG_DATA);
}
